export default __webpack_public_path__ + "img/74ce2ef18ef0043683e54f838a278432.wav";